import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from '../../actions/accountControlPanel';
import { ExtensionType } from '../../types/Extension';
import { ActiveSessionInfo } from '../../actions/accountControlPanel/payloads';
import { ServiceFeature } from '../../types/ServiceFeature';

export interface AccountControlPanelStateType {
    isLoadingAccountDetails?: boolean;
    accountDetails?: ExtensionType;
    isLoadingActiveSessionsInfo?: boolean;
    activeSessionInfo?: ActiveSessionInfo; 
    isLoadingServiceFeatures?: boolean;
    accountServiceFeatures?: ServiceFeature[];
}

export const initialState: AccountControlPanelStateType = {
    isLoadingAccountDetails: true,
};

export type AccountControlPanelActionsType = ActionType<typeof actions>;

const accountControlPanelReducer = createReducer<
    AccountControlPanelStateType,
    AccountControlPanelActionsType
>(initialState)
    .handleAction(actions.getAccountPanelAccountDetails.request, (state) => ({
        ...state,
        isLoadingAccountDetails: true,
        accountDetails: undefined,
    }))
    .handleAction(actions.getAccountPanelAccountDetails.success, (state, action) => ({
        ...state,
        isLoadingAccountDetails: false,
        accountDetails: action.payload
    }))
    .handleAction(actions.getAccountPanelAccountDetails.failure, (state) => ({
        ...state,
        isLoadingAccountDetails: false,
    }))
    .handleAction(actions.getLastWrapUpActiveCall.request, (state) => ({
        ...state,
        isLoadingActiveSessionsInfo: true,
        activeSessionInfo: undefined,
    }))
    .handleAction(actions.getLastWrapUpActiveCall.success, (state, action) => ({
        ...state,
        isLoadingActiveSessionsInfo: false,
        activeSessionInfo: action.payload
    }))
    .handleAction(actions.getLastWrapUpActiveCall.failure, (state) => ({
        ...state,
        isLoadingActiveSessionsInfo: false,
    }))
    .handleAction(actions.getAccountDashboardServiceFeatures.request, (state) => ({
        ...state,
        isLoadingServiceFeatures: true,
        accountServiceFeatures: undefined,
    }))
    .handleAction(actions.getAccountDashboardServiceFeatures.success, (state, action) => ({
        ...state,
        isLoadingServiceFeatures: false,
        accountServiceFeatures: action.payload
    }))
    .handleAction(actions.getAccountDashboardServiceFeatures.failure, (state) => ({
        ...state,
        isLoadingServiceFeatures: false,
    }));

export default accountControlPanelReducer;
